<template>
  <div>
    <Heade>
      <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/')"></template>
      <template v-slot:title>急诊科故事</template>
    </Heade>
    <!-- <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide"> <img src="../../assets/img/banner.png"/></div> -->
            <!-- <div class="swiper-slide">Slide 2</div>
            <div class="swiper-slide">Slide 3</div> -->
        <!-- </div>
    </div> -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" >
      <van-swipe-item>
        <img src="../../assets/img/banner820.jpg" alt="">
      </van-swipe-item>
       <van-swipe-item>
        <img src="../../assets/img/banner8202.png" alt="">
      </van-swipe-item>
    </van-swipe>
    <div class="flex spaceBetween ship">
        <div class="flex zong">
          <div class="imgBoxsp"><img src="../../assets/img/sp_1.png"/></div>
          <div class="col"> <div class="tit">{{videoNum}}</div> <div class="tip">视频总数</div> </div>
        </div>  
        <div class="flex zong">
          <div class="imgBoxsp"><img src="../../assets/img/sp_2.png"/></div>
          <div class="col"> <div class="tit">{{all_vote_num}}</div> <div class="tip">总票数</div> </div>
        </div>  
        <div class="flex zong">
          <div class="imgBoxsp"><img src="../../assets/img/sp_3.png"/></div>
          <div class="col"> <div class="tit">{{all_forward_num}}</div> <div class="tip">总转发量</div> </div>
        </div>                
    </div>
    <div v-if="isShow"  class="page" :style="{height: curHeight + 'px'}">
      <div class="containerNew"  v-for="(item,index) in List" :key="index" >
          <div class="base" @click='openVideo(item.id,item.video_id,item.view_num)'>              
              <div class="content">
                  <div class="flex">
                    <div class="myImg"> <img :src="item.video_cover_url" alt=""> </div>
                    <div class="rightBox">
                      <div class="firstrow">NO.{{item.number}}：{{item.interduce}}</div>
                      <div class="secrow">{{item.origin}}</div>
                      <div class="thirow">{{item.text_desc}}</div>
                    </div>
                  </div>
                  <div class="tiao">
                      <div class="flex spaceBetween">
                          <div class="flex">
                            <div class="imgBox one"><img src="../../assets/img/sp_3.png"/></div>
                            <div>{{item.forward_num ? item.forward_num : 0}}次转发</div>
                          </div>  
                          <div class="flex">
                            <div class="imgBox short"><img src="../../assets/img/sp_2.png"/></div>
                            <div>{{item.vote_num ? item.vote_num : 0}} 票</div>
                          </div>  
                          <div class="flex">
                            <div class="imgBox"><img src="../../assets/img/zan_3.png"/></div>
                            <div>{{item.praise_num ? item.praise_num : 0}} 赞</div>
                          </div>                 
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <div class="container"  v-for="(item,index) in List" :key="index" >
          <div class="base" @click='openVideo(item.id,item.video_id,item.view_num)'>
              <div class="myImg">
                  <img :src="item.video_cover_url" alt="">
                  <div class="title">急先锋-{{item.interduce}}</div>
              </div>
              <div class="content">
                  <div class="content_top"><span>视频来源：</span>{{item.origin}}</div>
                  <div class="flex">
                      <div class="no"> NO.{{item.number}} </div>
                      <div class="flex spaceBetween">
                          <div class="flex">
                            <div class="imgBox one"><img src="../../assets/img/spjs_1.png"/></div>
                            <div>{{item.forward_num ? item.forward_num : 0}}次转发</div>
                          </div>  
                          <div class="flex">
                            <div class="imgBox short"><img src="../../assets/img/spjs_2.png"/></div>
                            <div>{{item.vote_num ? item.vote_num : 0}} 票</div></div>  
                          <div class="flex">
                            <div class="imgBox"><img src="../../assets/img/spjs_3.png"/></div>
                            <div>{{item.praise_num ? item.praise_num : 0}} 赞</div>
                          </div>                 
                      </div>
                  </div>
              </div>
          </div>
      </div> -->
    </div>

    <div class="none" v-if="!isShow">
      <img src="../../assets/img/空.png" alt="">
    </div>
    
  </div>
</template>
<script>
import Swiper from 'swiper'; //导入
var wx = require('weixin-js-sdk');
export default {
  data() {
    return {
      List: [],
      isShow: false,
      curHeight: 0,
      videoNum: 0,
      all_vote_num: 0,
      all_forward_num: 0,
    };
  },
  //接收来自父组件的数据
  props: {},
  //生命周期实例创建完成后被立即调用
  created() {},
  beforeMount() {   
      this.$nextTick(function () {
        this.pageHeight = document.documentElement.clientHeight || document.body.clientHeight; 
        this.headerHeight = document.getElementsByClassName("header")[0].clientHeight;
        this.bannerHeight = document.getElementsByClassName("my-swipe")[0].clientHeight;
        this.dataHeight = document.getElementsByClassName("ship")[0].clientHeight;
        this.curHeight = this.pageHeight - this.headerHeight - this.bannerHeight - this.dataHeight; //减去页面上固定高度height
      })
  },
  //生命周期挂载完成之后被调用
  mounted() {
      this.getList();
      this.getVideoCountInfo();
    //   new Swiper ('.swiper-container', {
    //   loop: true,
    // })
    this.connectWx();
  },
  //组件
  components: {},
  //方法
  methods: {    
    openVideo(id, video_id,view_num) {
      console.log(id, video_id);
      this.$router.push({
        path:'/jizhenkePlay',
        query:{
          path:'/jizhenkeVedio',
          view_num: view_num,          
          video_id: video_id,          
          id: id,
        }
      });
      //  window.location.href="./video.html?meeting_field="+meeting_field+"&id="+id+"&video_id="+video_id;
    },
    //获取列表
    getList() {
      const url = "/api/videoRecord/getJxfVideoList";
      this.axios.post(url,{type:2}).then(res => {
        console.log(res);
        if (res.data.code === "00000") {
          const data = res.data.rows;
          if (data.length > 0) {
            this.isShow = true;
            this.List = res.data.rows;
          } else {
            this.isShow = false;
          }          
        }
      });
    },
    getVideoCountInfo(){
      const url = "/jxf/getVideoCountInfo";
      this.axios.post(url,{}).then(res => {
        if (res.data.code === "00000") {
          const data = res.data.model;  
          console.log("数据",data);        
          this.videoNum = data.videoNum ? data.videoNum : 0
          this.all_vote_num = data.all_vote_num ? data.all_vote_num : 0
          this.all_forward_num = data.all_forward_num ? data.all_forward_num : 0
        }
      });
    },
    connectWx(){
      const url = "/jxf/getSiginConfig";
      let params = {
          configUrl:location.href.split('#')[0]
      }                    
      this.axios.post(url,params,
      { transformRequest: function (params) {return JSON.stringify(params);},
      headers: {'Content-Type': 'application/json;charset=UTF-8'}
      }).then(res => {
          if (res.data.code === "00000") { 
              const _this = this;  
              let datad = res.data.model        
              wx.config({
      　　　　　　debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
      　　　　　　appId: datad.appId, // 必填，公众号的唯一标识
      　　　　　　timestamp: datad.timestamp, // 必填，生成签名的时间戳
      　　　　　　nonceStr: datad.nonceStr, // 必填，生成签名的随机串
      　　　　　　signature: datad.signature,// 必填，签名，见附录1
      　　　　　　jsApiList: [
      　　　　　　　　"onMenuShareAppMessage",'onMenuShareTimeline'
      　　　　　　] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      　　　　});
              wx.ready(function () {   //需在用户可能点击分享按钮前就先调用 
                  let Url =  location.href.split('?')[0]
                  Url = `${Url}#/jizhenkeVedio`;
                  let imgUrl = 'http://qxts.oss-cn-zhangjiakou.aliyuncs.com/img/jxflogo.112ea0c8.png'
                  wx.onMenuShareAppMessage({ 
                      title: '投票啦，快来pick出您心中最最喜爱的急诊科故事！', // 分享标题
                      desc: '急先锋 “急诊室的故事”微视频投票活动开始啦！一起品味急诊科惊心动魄或者暖人心扉的故事，点击进入投票，请投出您宝贵的一票', // 分享描述
                      link: Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                      imgUrl: imgUrl, // 分享图标
                      success: function () {
                          // 设置成功
                          console.log("自定义分享成功回调！")
                      }
                  })
                  wx.onMenuShareTimeline({ 
                      title: '投票啦，快来pick出您心中最最喜爱的急诊科故事！', // 分享标题
                      desc: '急先锋 “急诊室的故事”微视频投票活动开始啦！一起品味急诊科惊心动魄或者暖人心扉的故事，点击进入投票，请投出您宝贵的一票', // 分享描述
                      link: Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                      imgUrl: imgUrl, // 分享图标
                      success: function () {
                          // 设置成功
                          console.log("自定义分享成功回调！")
                      }
                  })                                
              });
      　　　　wx.error(function (res) {
      　　　　　　console.log("接入微信",res);
      　　　　});
          }
      });
      
  },
  },
  //监视
  watch: {}
};
</script>
<style lang="less" scoped>
@import "../../../node_modules/swiper/swiper.less";
.my-swipe {
  color: #fff;
  font-size: 40px;
  height: 422px;
  line-height: 422px;
  text-align: center;
  background-color: #39a9ed;
  img{
    width: 100%;
  }
}
.page{
  background: #f2f2f2;
  overflow: scroll;
  padding: 30px 0;
  box-sizing: border-box;
}
.containerNew {
  width: 100%;
  // margin-bottom: 30px;
  box-sizing: border-box;
  border: 1px solid #E6E6E6;
  .base {
    width: 100%;
    // border-radius: 20px;
    background: #ffffff;
    .myImg {
      width: 45%;
      height: 170px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        border-radius: 0 0 20px 20px;
        min-width: 100%;
        max-width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        line-height: 60px;
        background-color: #004d7d;
        box-sizing: border-box;
        padding: 0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .content {
      // font-size: 24px;
      // color: #999;
      box-sizing: border-box;
      padding: 30px 30px 20px;
      .content_top {
        margin-bottom: 16px;
      }
      .content_dow {
        display: flex;
        .title {
          color: #333;
        }
        .expertList {
          .name {
            margin-bottom: 8px;
          }
        }
      }
      span {
        color: #333;
      }
    }
  }
  .rightBox{
    width: 55%;
    padding-left: 5%;
    box-sizing: border-box;
  }
  .tiao{
    background: #F2F2F2;
    padding: 18px 10px;
    border-radius: 16px;
    margin-top: 20px;
  }
  .firstrow{    
    font-size: 28px;
    font-weight: bold;
    color: #333333;
  }
  .secrow{    
    // width: 100%;
    // height: 46px;
    font-size: 24px;
    background: #e8eff9;
    color: #2D5FA7;
    border-radius: 16px;
    // line-height: 46px;
    text-align: center;
    margin: 30px 0 15px;
    padding: 5px 10px;
  }
  .thirow{    
    // width: 80%;      
    font-size: 26px;
    color: #999999;      
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.flex{
  display: flex; 
  flex-direction: row;
  font-size: 24px;
  align-items: center; 
  .no{
    font-size: 32px;
    padding-right: 16px;
    margin-right: 16px;
    border-right: 1px solid #EBEBEB;
  }
}
.col{
  display: flex; 
  flex-direction: column;
  .tit{
    font-size: 36px;
    color: #333333;
  }
  .tip{
    font-size: 26px;
    color: #d0d0d0;
  }
}
.spaceBetween{
  justify-content: center;
  width: 100%;
  .flex{
    margin: 0 50px;
  }
  .zong{
    margin: 0 30px;
  }
}
.ship{
  height: 140px;
  // padding: 0 60px;
  box-sizing: border-box;
  background: white;
}
.imgBoxsp{
  width: 52px;
  margin-right: 12px;
  img{
    width: 100%;
  }
}
.imgBox{
  width: 30px;
  height: 30px;
  // margin-top:3px;
  margin-right: 8px;
  img{
    width: 100%;
  }
}
.swiper-slide img{
  width: 100%;
}
.container {
  width: 100%;
  margin-bottom: 30px;
  box-sizing: border-box;
  // padding: 30px 30px 0;
  .base {
    width: 100%;
    border-radius: 20px;
    background: #ffffff;
    .myImg {
      width: 100%;
      height: 388px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 20px 20px 0 0;
      }
      .title {
        border-radius: 0 0 20px 20px;
        min-width: 100%;
        max-width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        line-height: 60px;
        background-color: #004d7d;
        box-sizing: border-box;
        padding: 0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .content {
      // font-size: 24px;
      // color: #999;
      box-sizing: border-box;
      padding: 30px;
      .content_top {
        margin-bottom: 16px;
      }
      .content_dow {
        display: flex;
        .title {
          color: #333;
        }
        .expertList {
          .name {
            margin-bottom: 8px;
          }
        }
      }
      span {
        color: #333;
      }
    }
  }
}
.none {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin-top: 160px;
    width: 530px;
    height: 440px;
  }
}
</style>